import { Link } from "react-router-dom";
import { PARCEL_STATUS_LABELS, JEWELRY_STATUS_LABELS } from "@/lib/format";

export const StatusBadge = ({ status, kind = "parcel", testid, linkTo }) => {
    const labels = kind === "parcel" ? PARCEL_STATUS_LABELS : JEWELRY_STATUS_LABELS;
    const map = {
        available: "bg-emerald-50 text-emerald-700 border-emerald-500/40",
        split: "bg-sky-50 text-sky-700 border-sky-500/40",
        in_production: "bg-amber-100 text-amber-700 border-amber-500/40",
        set_in_jewelry: "bg-violet-50 text-violet-700 border-violet-500/40",
        sold: "bg-stone-200 text-stone-500 border-stone-400",
    };
    const cls = `inline-flex items-center px-1.5 py-0.5 text-[9px] uppercase tracking-widest border ${map[status] || map.available}`;
    const body = labels[status] || status;
    if (linkTo) {
        return <Link to={linkTo} className={`${cls} hover:opacity-80 transition-opacity`} data-testid={testid}>{body}</Link>;
    }
    return <span className={cls} data-testid={testid}>{body}</span>;
};

export default StatusBadge;
